import { z } from 'zod';
export const logBadgeHistoryActionRequestSchema = z.object({
    badgeId: z.string().uuid(),
    accountBadgeIds: z.string().uuid().array().min(1),
    action: z.enum(['accountBadgeNotificationSent', 'accountBadgePrinted']),
});
export const logBadgeHistoryActionResponseSchema = z.object({
    success: z.boolean(),
});
export const logBadgeHistoryActionFunctionDef = {
    name: 'logBadgeHistoryAction',
    requestSchema: logBadgeHistoryActionRequestSchema,
    responseSchema: logBadgeHistoryActionResponseSchema,
};
